import { useEffect } from 'react';

const useScrollToTop = <T>(condition: T) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [condition]);
};

export default useScrollToTop;
